module.exports = __webpack_public_path__ + "../resources/img/bg_box03_02.d0eb0cca.png";